(function () {
  function initCarousel(section) {
    if (window.innerWidth > 767) return;

    var grid     = section.querySelector('.fp-reviews__grid');
    var dotsWrap = section.querySelector('.fp-reviews__dots');
    if (!grid || !dotsWrap || dotsWrap.childElementCount > 0) return;

    var items = Array.from(grid.children);

    items.forEach(function (item, idx) {
      var dot = document.createElement('button');
      dot.className = 'fp-reviews__dot' + (idx === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Review ' + (idx + 1));
      dot.addEventListener('click', function () {
        var pl = parseInt(getComputedStyle(grid).paddingLeft) || 0;
        grid.scrollTo({ left: item.offsetLeft - pl, behavior: 'smooth' });
      });
      dotsWrap.appendChild(dot);
    });

    var dots = dotsWrap.querySelectorAll('.fp-reviews__dot');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          var idx = items.indexOf(entry.target);
          if (idx < 0) return;
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        }
      });
    }, { root: grid, threshold: 0.5 });

    items.forEach(function (item) { observer.observe(item); });
  }

  function init() {
    document.querySelectorAll('.fp-reviews').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
